import Phaser from 'phaser';
import { GAME_WIDTH, GAME_HEIGHT } from '@hokm/shared';

/**
 * Creates a subtle textured background with a felt-like appearance.
 */
export class BackgroundTexture {
  private graphics: Phaser.GameObjects.Graphics[] = [];

  constructor(private scene: Phaser.Scene) {
    this.createVignette();
    this.createNoisePattern();
    this.createFabricLines();
  }

  private createVignette(): void {
    const graphics = this.scene.add.graphics();
    this.graphics.push(graphics);
    const centerX = GAME_WIDTH / 2;
    const centerY = GAME_HEIGHT / 2;

    // Draw concentric rectangles for vignette effect
    const steps = 8;
    for (let i = steps; i >= 0; i--) {
      const alpha = 0.03 * (steps - i);
      const scale = 1 + i * 0.15;
      graphics.fillStyle(0x0a2a1a, alpha); // Darker green
      graphics.fillRect(
        centerX - (GAME_WIDTH * scale) / 2,
        centerY - (GAME_HEIGHT * scale) / 2,
        GAME_WIDTH * scale,
        GAME_HEIGHT * scale
      );
    }
  }

  private createNoisePattern(): void {
    const noiseGraphics = this.scene.add.graphics();
    this.graphics.push(noiseGraphics);

    // Lighter speckles
    for (let i = 0; i < 150; i++) {
      const x = Math.random() * GAME_WIDTH;
      const y = Math.random() * GAME_HEIGHT;
      const size = Math.random() * 2 + 0.5;
      noiseGraphics.fillStyle(0x2a6a4a, Math.random() * 0.15 + 0.05);
      noiseGraphics.fillCircle(x, y, size);
    }

    // Darker speckles
    for (let i = 0; i < 100; i++) {
      const x = Math.random() * GAME_WIDTH;
      const y = Math.random() * GAME_HEIGHT;
      const size = Math.random() * 1.5 + 0.5;
      noiseGraphics.fillStyle(0x0a3a2a, Math.random() * 0.12 + 0.03);
      noiseGraphics.fillCircle(x, y, size);
    }
  }

  private createFabricLines(): void {
    const lineGraphics = this.scene.add.graphics();
    this.graphics.push(lineGraphics);
    lineGraphics.lineStyle(1, 0x1a5a3a, 0.08);
    for (let y = 0; y < GAME_HEIGHT; y += 12) {
      lineGraphics.beginPath();
      lineGraphics.moveTo(0, y);
      lineGraphics.lineTo(GAME_WIDTH, y);
      lineGraphics.strokePath();
    }
  }

  destroy(): void {
    this.graphics.forEach((g) => g.destroy());
    this.graphics = [];
  }
}
